import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';

import { EMPTY, from, Observable, of, throwError } from 'rxjs';
import { catchError, switchMap, take } from 'rxjs/operators';

import { ApiFragment, Identifier, sessionStorageHelper } from '@stylehaven/components';
import { RecordHolderService } from './record-holder.service';

@Injectable({ providedIn: 'root' })
export class RecordHolderInitializerService {
    private readonly router: Router = inject(Router);
    constructor(protected recordHolderService: RecordHolderService) {}
    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): ApiFragment | undefined | Observable<ApiFragment | undefined> | Promise<ApiFragment | undefined> {
        const identifier: Identifier | null = route.paramMap.get('recordId') as Identifier | null;

        if (identifier === null) {
            return throwError('fragmentId is undefined');
        }

        const parentUrl = route.pathFromRoot.map(r => r.url.map(u => u.path).join('/')).join('/');

        return this.recordHolderService.loadRecord(identifier).pipe(
            switchMap(record => {
                if (sessionStorageHelper.has('shareToken') && record.isDeleted()) {
                    return from(this.router.navigate([parentUrl, 'removed'], { skipLocationChange: true })).pipe(
                        switchMap(() => EMPTY)
                    );
                }

                return of(record);
            }),
            take(1),
            catchError(this.handleGetRecordError.bind(this))
        );
    }

    private handleGetRecordError(error: Error): Observable<undefined> {
        return of(undefined);
    }
}
